import { render, staticRenderFns } from "./userAdd.vue?vue&type=template&id=3115c115&scoped=true"
import script from "./userAdd.vue?vue&type=script&lang=js"
export * from "./userAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115c115",
  null
  
)

export default component.exports